import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, Menu, Tooltip } from 'antd';
import { ClickableIcon } from '../../../common/components';
import { FilterIcon, CheckIconBold } from '../../../custom_shared/icons';
import { CustomDivider } from '../../../custom_shared/components';
import { WorksheetStatusFilter } from '../../types';
import { useAppStore } from '../../stores';
import './WorksheetsFilter.less';

const WorksheetsFilter: React.FC = () => {
    const { worksheetsStore } = useAppStore();

    const [menuVisible, setMenuVisible] = React.useState(false);

    const handleFilterClick = (filter: WorksheetStatusFilter) => {
        worksheetsStore.setWorksheetStatusFilter(filter);

        if (worksheetsStore.filteredWorksheets.length) {
            worksheetsStore.selectWorksheet(worksheetsStore.filteredWorksheets[0]);
            return;
        }

        if (worksheetsStore.selectedWorksheet) {
            worksheetsStore.selectedWorksheet.setIsSelected(false);
        }
    };

    const renderFilterItem = (filter: WorksheetStatusFilter, label: string) => (
        <Menu.Item key={filter} onClick={() => handleFilterClick(filter)}>
            <div className="dropdown-icon-container">
                {worksheetsStore.worksheetStatusFilter === filter && (
                    <CheckIconBold width={16} height={16} color="#000" />
                )}
            </div>

            <span className={`dropdown-label ${filter.toLowerCase()}`}>{label}</span>
        </Menu.Item>
    );

    const moreActionsMenu = (
        <Menu onClick={() => setMenuVisible(false)}>
            {renderFilterItem('All', 'All statuses')}
            {renderFilterItem('Unprocessed', 'Unprocessed')}
            {renderFilterItem('Successful', 'Successful')}
            {renderFilterItem('Failed', 'Failed')}
            <CustomDivider type="horizontal" />
            {renderFilterItem('OnlyWithChanges', 'Only with changes')}
            <CustomDivider type="horizontal" />
            {renderFilterItem('HideSuccessful', 'Hide successful')}
        </Menu>
    );

    return (
        <Dropdown
            overlayClassName="worksheets-filter-dropdown"
            placement="bottomLeft"
            visible={menuVisible}
            overlay={moreActionsMenu}
            onVisibleChange={setMenuVisible}
            trigger={['click']}
        >
            <Tooltip title="Filter worksheets" placement="bottom">
                <span className="worksheets-filter-trigger">
                    <ClickableIcon
                        icon={FilterIcon}
                        style={{ width: 20, height: 20 }}
                        color="#717887"
                        aria-label="Filter worksheets"
                        onClick={() => setMenuVisible(true)}
                    />
                </span>
            </Tooltip>
        </Dropdown>
    );
};

export default observer(WorksheetsFilter);
